import React from 'react';
import Ionicon from "react-ionicons";

export default function ErrorModal(props) {
    const { isOpen, onClose, message } = props;
    if (isOpen === false)
        return null;
    return (
        <div className="popup-default">
            <div className="popup-inner">
                <div className="popup-content--error">

                    <button className="close-popup" type="button" onClick={(e) => onClose(e)}>
                        <Ionicon icon="ion-close" />
                    </button>
                    <h3 className="h3 white-text">Error</h3>
                    <p className="p-tag white-text">{message}</p>
                    <button type="button" className="btn btn-primary" onClick={(e) => onClose(e)}>
                        <span className="label">Close</span>
                        <span className="icon"><i className="fa fa-angle-right animated-right" /></span>
                    </button>
                </div>

            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// src/client/components/common/elements/ErrorModal.js